export default {
    TnS_FolderPaneChange: {
        datapoint: {
            name: 'TnS_FolderPaneChange',
            customData: function (folderExpansionSource, isCollapsedAndNonDynamic, showFolderPane, isNonDynamicFolderExpansionMode, browserWidth) { return [
                folderExpansionSource,
                isCollapsedAndNonDynamic,
                showFolderPane,
                isNonDynamicFolderExpansionMode,
                browserWidth,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map